import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

export default function BassinFace() {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "bassin_ballon.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  return (
    <Img
      fluid={data.file.childImageSharp.fluid}
      alt="Deux ballons devant le bassin de la piscine"
      className="shadow-lg rounded-lg my-4 md:my-6 md:ml-4 w-full md:w-1/2 float-right"
    />
  );
}
